import { createNavigation } from 'next-intl/navigation';
import { defineRouting } from 'next-intl/routing';

import { localePrefix, locales, pathnames } from '@/i18n/i18n.config';

export const routing = defineRouting({
    locales: locales,
    defaultLocale: 'en',
    pathnames: pathnames,
    localePrefix: localePrefix,
    // next-intl otherwise sets a `Link: <…>; rel="alternate"; hreflang="…"` response header from
    // the middleware, built out of `request.nextUrl` — i.e. the origin host once a CDN fronts the
    // app, which publishes `origin.cinema-website.cineamo.dev` to search engines as the canonical
    // alternate for every customer page.
    //
    // Rewriting its host would work, but the header is redundant anyway: every page already emits
    // hreflang in <head> via getPageAlternates(), resolved against the public metadataBase. That
    // version is strictly better — it knows the localized pathnames, it carries x-default, and it
    // is absent on pages that notFound(), which the blanket header is not. Two disagreeing sets of
    // hreflang is worse than one.
    alternateLinks: false,
    localeDetection: false,
    localeCookie: false
});

export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing);
